import React, { useEffect, useState } from "react";
import { useGetLogspaginationQuery } from "src/services/ContactServices";
import EmailsTab from "./EmailsTab";
import { useParams } from "react-router-dom";

const EmailsTabWrapper = () => {
  const { contactId } = useParams();
  const [emailsData , setEmailsData] = useState<any>()

  const { data, isLoading, isFetching } = useGetLogspaginationQuery({
    limit: 10,
    searchValue: "",
    params: ["description"],
    page: 0,
    filterBy: [
      {
        fieldName: "contactId",
        value: [contactId || ''],
      },
      {
        fieldName: "logType",
        value: ["EMAIL"],
      },
    ],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: false,
  });

   useEffect(()=>{
    if(!isLoading && !isFetching){
        setEmailsData(data?.data) 
    }

   },[data, isLoading, isFetching])



  return <EmailsTab isLoading= {isLoading || isFetching} emailsData={emailsData} />;
};

export default EmailsTabWrapper;
